module.exports = __webpack_public_path__ + "static/bradesco-2-eb718f3d7eea1faae2435d6bb38ceb76.jpg";